import { Core } from "@faire/design-tokens";
import { Row, VerticalLine } from "@faire/web/slate/Layout";
import { FaireLogo } from "@faire/web/slate/logos/FaireLogo";
import React from "react";
import styled from "styled-components";

import { AmexLogo } from "@faire/retailer/views/amex/AmexLogo";
import { SquareLogo } from "@faire/retailer/views/PartnershipIncentiveLanding/SquareLogo";

export const PartnershipLogos: React.FC<{ isAmex: boolean }> = ({ isAmex }) => {
  return (
    <Row gap={30} align="center">
      <StyledFaireLogo />
      <VerticalLine
        $height="40px"
        $color={Core.surface.inverse}
        $stroke="1px"
      />
      {isAmex ? <AmexLogo /> : <SquareLogo color={Core.icon.inverse} />}
    </Row>
  );
};

const StyledFaireLogo = styled(FaireLogo).attrs({
  inverse: true,
})`
  width: 110px;
`;
